import { render, staticRenderFns } from "./ContractsTemplateRecord.vue?vue&type=template&id=29467278&scoped=true"
import script from "./ContractsTemplateRecord.vue?vue&type=script&lang=js"
export * from "./ContractsTemplateRecord.vue?vue&type=script&lang=js"
import style0 from "./ContractsTemplateRecord.vue?vue&type=style&index=0&id=29467278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29467278",
  null
  
)

export default component.exports